<template>
    <div class="item-wrapper">
        <div class="current-label" :class="{ 'item-selected': isSelected }">
            <div class="label" :style="{ 'font-size': '14px' }" @click="labelClick">
                <div class="node-label" v-if="!editing" :title="data.label">{{ data.label }}</div>
                <span v-if="editing"><input v-model="editVal" class="edit-input" @keypress="keyPressHandler" ref="labelInput"/></span>
                <em class="small-label">({{ data.subLabel }})</em>
            </div>
            <div class="operator" v-if="editable">
                <ItemEditPanel :actionTypes="actionTypes" @oprClick="operateClick" @transferEnd="transferEnd" />
            </div>
        </div>
    </div>
</template>

<script>
import ItemEditPanel from "./itemEditPanel";

export default {
    name: "EditableListItem",
    props: {
        data: Object,
        editable: Boolean,
        actionTypes: Array,
        isSelected: Boolean
    },
    components: {
        ItemEditPanel
    },
    data() {
        return {
            editVal: this.data.label,
            editing: false
        };
    },
    mounted() {
        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    },
    methods: {
        labelClick() {
            this.$emit("selectItem", this.data);
        },
        operateClick(opr) {
            if (opr == "edit") {
                this.editVal = this.data.label;
                this.editing = true;
                setTimeout(() => {
                    this.$refs.labelInput && this.$refs.labelInput.focus();
                }, 50);
            } else {
                this.$emit("operatorClick", {
                    actionType: opr,
                    record: this.data
                });
            }
        },
        transferEnd(newIdx) {
            this.$emit("transferEnd", {
                path: this.data.id,
                newIdx
            });
        },
        keyPressHandler(event) {
            const isEnterKey = event.keyCode === 13;
            if (isEnterKey) {
                this.editing = false;
                this.emitEditEvent();
            }
        },
        emitEditEvent() {
            const newLabel = this.zhiji.strTrim(this.editVal);
            const isChanged = newLabel != this.data.label;
            this.editing = false;

            newLabel &&
                this.$emit("operatorClick", {
                    actionType: "edit",
                    record: {
                        id: this.data.id,
                        label: this.data.label,
                        newLabel: newLabel,
                        isChanged
                    }
                });
        },
        windowClick(event) {
            if (this.editing && this.zhiji.isClickOuter(event, "current-label")) {
                this.emitEditEvent();
            }
        }
    }
};
</script>

<style lang="less" scoped>
.item-wrapper {
    position: relative;
    cursor: pointer;

    .edit-input {
        padding: 5px 0;
        width: 120px;
        border: 1px solid #d8e4f0;
        box-sizing: border-box;
        border-radius: 4px;
        margin-left: 12px;
        outline: none;
        &:focus {
            border: 1px solid #2088f3;
            border-radius: 4px;
        }
    }

    .small-label {
        color: #9b9ba3;
        font-size: 12px;
    }

    .operator {
        position: absolute;
        right: 0;
        top: 0;
        padding: 1px 11px 0 11px;
        transform: translateX(110%);
        font-size: 0;
        white-space: nowrap;
        vertical-align: middle;
        background: #fbfbff;
        box-sizing: border-box;
        transition: transform 0.3s ease-in-out;
        z-index: 1;
    }

    &.moving {
        background: #fafbfd !important;
        & > .current-label {
            box-shadow: 0 0 8px rgba(46, 98, 151, 0.2) !important;

            .label {
                background: transparent !important;
            }

            .operator {
                transform: translateX(0) !important;
                transition: none;
                padding: 0 11px !important;
                background: linear-gradient(to left, #fbfdff 97%, #ebeff5 97.5%, #eef2f7 98%, #f7f8f9 98.5%, #f7f8fa 99%, #f4f7fa) !important;
            }
        }
    }

    .node-label {
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        height: 18px;
        line-height: 16px;
        vertical-align: middle;
        max-width: calc(100% - 94px);
        text-overflow: ellipsis;
        padding-left: 16px;
    }

    .current-label {
        width: 100%;
        line-height: 48px;

        .label {
            width: 100%;
        }

        &:hover {
            .label {
                background: rgba(217, 235, 246, 0.7);
                color: #2ec2ff;

                .small-label {
                    color: #2ec2ff;
                }
            }

            .operator {
                transform: translateX(0);
                background: linear-gradient(to left, #fbfdff 96%, #dcebf5 96.5%, #dae9f4 98%, #e1eff7 98.5%, #deecf6 99%, #e4f1f9);
            }
        }
    }

    .item-selected {
        .label {
            color: #2ec2ff;
            background: rgba(217, 235, 246, 1);
            .small-label {
                color: #2ec2ff;
            }
        }
    }
}
</style>
